module.exports = __webpack_public_path__ + "img/successyuan.fdf13883.svg";